import React from 'react';
import { Link } from "react-router-dom";
import '../CSS_stuff/CSSabout.css';
import pic from '../assets/AuthorPinkHatRosewaterPic.jpg';

const About = () => {
  // 1) Define a multiline string with backticks
  const aboutText = `
Mangala McNamara writes Epic Fantasy with a Helping of Sugar and Spoonful of Spice.

She is an Indian-American former Biologist who lives in Flyover Country (the far northern end of the US South) with her husband and three of her six children. The others are in college – you can blame kid #1 for the excessive amounts of math in her novels, #2 for better attention to staging of scenes, #3 for all the economics, and #4 for great attention to history – and all of them for a focus on political science!

Mangala is a former bellydance instructor, and used to enjoy knitting, crotchet and embroidering Temari balls but now is much more boring as she rarely does anything but write… and occasionally fence (the sport) and play boardgames with her kids. She owes her love of books to her mother, a professional folklorist who could recite stories from every nation in the United Nations.
  `.trim();  // .trim() just removes the leading/trailing blank lines

  return (
    <div className="centered-card-wrapper">
      <div className="centered-card">
        <img
          src={pic}
          alt="Mangala McNamara wearing a pink hat at the Rosewater bookstore"
          className="centered-card-image"
        />

        {/* 2) Render the multiline text */}
        <p className="centered-card-text">
          {aboutText}
        </p>
        
        <p>
          Want Three Free Stoties?
        </p>
        <Link to="/newsletter" className="contact-info">
          Join my newsletter
        </Link>
      </div>
    </div>
  );
};

export default About;